"use client";
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Col, Form, Row} from "react-bootstrap";
import Title from "@/components/Title";
import Select from "react-select";
import Button from "@/components/Button";
import ThemeContainer from "@/components/theme/container";
import Chart from 'chart.js/auto';

const Calculator = ({img, text, title, total, stock}) => {
    // investor calculator

    const [startDate, setStartDate] = useState("");
    const [paymentError, setPaymentError] = useState("");
    const [yearError, setYearError] = useState("");
    const [paymentValue, setPaymentValue] = useState("");  // Track payment input
    const [isButtonDisabled, setIsButtonDisabled] = useState(true); // Button disabled state
    const [isResultFetched, setIsResultFetched] = useState(false); // Track if result is fetched

    function formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const [dataOption, setDataOption] = useState([]);

    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsYear, setSelectedOptionsYear] = useState([]);









    // Update button disabled state based on form inputs
    useEffect(() => {
        const isPaymentFilled = !!paymentValue;
        const isYearSelected = !!selectedOptionsYear;
        const hasStockSelected = selectedOptions.length > 0;

        // Disable button if required fields are empty or result has already been fetched
        setIsButtonDisabled(!(isPaymentFilled && isYearSelected && hasStockSelected) || isResultFetched);
    }, [paymentValue, selectedOptions, selectedOptionsYear, isResultFetched]);




    const handlePayment = (selected) => {
        setPaymentValue(selected.target.value); // Set payment value
        clearPaymentError();
        setIsResultFetched(false); // Reset result fetched state on change
    };
    // Function to handle the selected options
    const handleSelection = (selected) => {
        setSelectedOptions(selected);
        setIsResultFetched(false); // Reset result fetched state on change
    };

    const handleSelectionYear = (selected) => {
        setSelectedOptionsYear(selected?.value);
        clearYearError();
        setIsResultFetched(false); // Reset result fetched state on change
    };


    // Function to clear payment error message
    const clearPaymentError = () => {
        if (typeof document !== "undefined") {
            document.getElementById("paymentError").textContent = "";
        }
        setPaymentError("");
    };

    // Function to clear year error message
    const clearYearError = () => {
        if (typeof document !== "undefined") {
            document.getElementById("yearError").textContent = "";
        }
        setYearError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form submission

        // Reset error messages and clear any previous data
        clearPaymentError();
        clearYearError();
        document.getElementById("paymentError").textContent = "";
        document.getElementById("yearError").textContent = "";
        setDataOption([]); // Clear any previous chart data

        // Retrieve form inputs
        const paymentInput = document.querySelector('input[name="payment"]');
        const paymentValue = paymentInput.value;


        const selectedStocks = selectedOptions?.map((option) => option.value);
        const selectedStocksYear = selectedOptionsYear;
        const selectedDate = startDate
            ? formatDate(startDate)
            : formatDate(new Date());

        // Validate payment input
        if (!paymentValue) {
            setPaymentError("Enter starting amount.");
            return;
        }

        // Validate year input
        if (!selectedStocksYear || selectedStocksYear.length < 1) {
            setYearError("Select a year.");
            return;
        }

        try {
            // Fetch investor data from the API
            const response = await fetch(
                "https://cms.ucbstock.com.bd//wp-json/custom-api/v1/investor-data-new-new" +
                `?stock=${selectedStocks}&year=${selectedStocksYear}&payment=${paymentValue}`
            );
            const data = await response.json();

            // Extract required values from the API response

            // Update chart data
            setDataOption(data);

            // Update the result HTML with the calculated values
            const resultElement = document.querySelector(".result");

            const portfolio_return = data?.portfolioReturn?.toFixed(2);
            const formattedValue = (portfolio_return * 100).toFixed(0); // Result: "-46"

            if (resultElement) {
                const selectedOptionsList = selectedOptions
                    ?.map((e) => e?.label)
                    .join(", ");
                const lastIndex = selectedOptionsList.lastIndexOf(",");
                const formattedOptionsList =
                    lastIndex === -1
                        ? selectedOptionsList
                        : `${selectedOptionsList.slice(
                            0,
                            lastIndex
                        )} and ${selectedOptionsList.slice(lastIndex + 1)}`;

                resultElement.innerHTML = `
        <div class="result-wrp">
          <p>If you have invested equally in
            <span>${formattedOptionsList}</span>, <span>${selectedStocksYear}</span> years ago, today you would have had BDT (without dividend)</p>
          <div class="result-wrap-block">
            <ul>
            <li>
                <p>Total Portfolio Value</p>
                <p class="resutl">${data?.portfolioValue}</p>
              </li>
             <li>
                <p>Total Return (without dividend)</p>
                <p class="resutl">${formattedValue}%</p>
              </li>
              
            </ul>
          </div>
        </div>
      `;
            }
            setIsResultFetched(true); // Set result fetched to true on success
            setCan(true);
        } catch (error) {
            console.error("Failed to fetch data from the API:", error); // Handle error
        }
    };


    useEffect(() => {


        if (dataOption?.portfolioValue) {
            const labels = dataOption.stockReturns?.map((value) => value.stokename);
            let delayed;
            const data = {
                labels: labels,
                datasets: [
                    {
                        label: 'Stock Returns',
                        data: dataOption.stockReturns?.map((value) => Math.floor(value.value * 100 * 100) / 100), // Scale to percentage format
                        backgroundColor: '#E62E43',
                    },
                    {
                        label: 'Total Return',
                        data: Array(dataOption?.stockReturns?.length).fill(dataOption?.portfolioReturn),
                        type: 'line',
                        borderColor: '#115711',
                        borderWidth: 5,
                        fill: false,
                    }
                ],
            };
            new Chart(document.getElementById("line-chart"), {
                type: 'bar',
                data: data,

                options: {
                    interaction: {
                        intersect: false,
                        mode: 'index',
                    },
                    responsive: true,
                    scales: {
                        y: {
                            beginAtZero: true,
                            min: -100,
                            max: 100,
                            stacked: true
                        },
                    },
                    plugins: {
                        legend: {position: 'nearest'},
                        title: {display: false, text: 'Stock and Portfolio Returns'},
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }

                                    if (context.parsed.y !== null) {
                                        // Check dataset index to customize tooltip for each dataset
                                        if (context.datasetIndex === 0) {
                                            // Dataset 1: Stock Returns (add % to value)
                                            label += `${context.parsed.y.toFixed(2)}%`;
                                        } else if (context.datasetIndex === 1) {
                                            // Dataset 2: Portfolio Return (custom formatting, if needed)
                                            const portfolio_return = context.parsed.y.toFixed(2);
                                            const formattedValue = (portfolio_return * 100).toFixed(0); // Result: "-46"

                                            label += `${formattedValue}%`; // Assuming % for both
                                        }
                                    }

                                    return label;
                                }
                            },
                        },
                    },
                },
            });
        }
    }, [dataOption]);


    const stockColumns = stock?.stock_columns || []; // Ensure it's an array

    const DropdownOption = stockColumns
        .filter(stockName => stockName !== "Date") // Remove items named "Date"
        .map(stockName => {
            return {
                value: stockName, // Converting to lowercase for consistency
                label: stockName,  // Converting to uppercase for display
            };
        });


    const DropdownOptionYear = [
        {value: "2", label: "2 Years"},
        {value: "5", label: "5 Years"},
        {value: "10", label: "10 Years"},
    ];

    const CustomMultiValue = ({data}) => (
        <div>
            <span>{data.label}</span>
            <PlusIcon
                style={{
                    marginLeft: "5px",
                    verticalAlign: "middle",
                    marginRight: "5px",
                    top: "-2px",
                    position: "relative",
                }}
            />
        </div>
    );

    const CustomMultiValueLabel = ({data}) => (
        <div>
            <span>{data.label}</span>
            <PlusIcon
                style={{
                    marginLeft: "5px",
                    verticalAlign: "middle",
                    marginRight: "5px",
                    top: "-2px",
                    position: "relative",
                }}
            />
        </div>
    );


    return (
        <StyledOverview className="calculator pt-200 ">
            <div className="investor_calculator">
                <ThemeContainer
                    colProps={{md: 12}}
                    colClassName={"modal-data__content"}
                >
                    <Row class={"row"}>
                        <Col className={"form"} md={6}>
                            <Title margin={"0 0 40px 0"} text={"Investment Calculator"}/>

                            <div className="form-wrapper-all">
                                <Form
                                    onSubmit={handleSubmit}
                                    method="post"
                                    enctype="multipart/form-data"
                                >
                                    <Row>
                                        <Form.Group className="col-md-12 pb-30 form-wrapper">
                                            <Form.Control
                                                className={"form-control-lg"}
                                                type="number"
                                                name="payment"
                                                placeholder="Starting Amount"
                                                required
                                                onChange={handlePayment}
                                                onInput={(e) => {
                                                    e.target.value = Math.max(0, parseInt(e.target.value))
                                                        .toString()
                                                        .slice(0, 12);
                                                }}
                                            />
                                            <div
                                                id="paymentError"
                                                className="calculator-error-message"
                                            >
                                                {paymentError}
                                            </div>
                                        </Form.Group>

                                        <Form.Group className="col-md-12 pb-30 form-wrapper">
                                            <Select
                                                isMulti
                                                placeholder={"Stock"}
                                                onChange={handleSelection} // replace with your selection handler function
                                                styles={{
                                                    dropdownIndicator: (provided, state) => ({
                                                        ...provided,
                                                        transform:
                                                            state.selectProps.menuIsOpen && "rotate(180deg)",
                                                    }),
                                                }}
                                                classNamePrefix={"react-select"}
                                                className={"form-select"}
                                                isSearchable={true}
                                                isOptionDisabled={() => selectedOptions.length >= (total ? total : 5)}
                                                options={DropdownOption} // replace with your dropdown options
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#e9e9e9",
                                                        primary: "black",
                                                    },
                                                })}
                                            />
                                            <p className={"hints"}>Select up to 5 Stocks</p>
                                        </Form.Group>

                                        <Form.Group className="col-md-12 pb-30 form-wrapper last">
                                            <Select
                                                placeholder={"Year"}
                                                name="year"
                                                onChange={handleSelectionYear} // replace with your selection handler function
                                                styles={{
                                                    dropdownIndicator: (provided, state) => ({
                                                        ...provided,
                                                        transform:
                                                            state.selectProps.menuIsOpen && "rotate(180deg)",
                                                    }),
                                                }}
                                                classNamePrefix={"react-select"}
                                                className={"form-select"}
                                                options={DropdownOptionYear} // replace with your dropdown options
                                                theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#e9e9e9",
                                                        primary: "black",
                                                    },
                                                })}
                                            />
                                            <div id="yearError" className="calculator-error-message">
                                                {yearError}
                                            </div>
                                        </Form.Group>

                                        <div className="clear"></div>

                                        <Form.Group
                                            className={`col-xl-6 widthHalf ${isButtonDisabled ? 'disable_calculator_button' : ''}`}
                                            onClick={handleSubmit}
                                        >
                                            <Button
                                                margin={"0 40px 0 0"}
                                                padding={"0"}
                                                hoverColor={"#3C3C3B"}
                                                hoverBackground={"#3C3C3B"}
                                                width={"auto"}
                                                text={"Calculate"}
                                                classname={"col-md-6"}
                                            />
                                        </Form.Group>
                                    </Row>
                                </Form>
                            </div>
                        </Col>

                        <Col md={{span: 5, offset: 1}} id={"result"} className={"result"}>
                            <div className="result-wrp"></div>
                        </Col>
                    </Row>
                    <Row className={"desktop-view-blog"}>
                        {dataOption?.portfolioValue && ( // Check both can and dataOption
                            <Col md={12}>
                                <br/>
                                <div className="relative chart-container h-350-px">
                                    <canvas id="line-chart"></canvas>
                                </div>
                            </Col>
                        )}
                    </Row>
                </ThemeContainer>
            </div>
        </StyledOverview>
    );
};

const StyledOverview = styled.section`
    padding-bottom: 120px;
    background: white;

    .dc-btn {
        width: fit-content;
    }
    .disable_calculator_button{
        .dc-btn{
            a{
                pointer-events: none;
                cursor: not-allowed;
                opacity: 0.5;
            }
        }
    }
    .react-select__menu {
        background: white !important;

        li {
            font-size: 14px !important;
            line-height: 20px !important;
            font-weight: 400 !important;
        }

        a {
            font-size: 14px !important;
            line-height: 20px !important;
            font-weight: 400 !important;
        }
    }

    .chart-container {
        height: 90vh;
        @media (max-width: 767px) {
            height: 400px;
        }
    }

    .title {
        h2 {
            font-size: 36px;
            line-height: 40px;
            letter-spacing: 0.5px;
            font-family: "Butler";
        }
    }

    .form-wrapper {
        position: relative;

        .calculator-error-message {
            position: absolute;
            bottom: 15px;
        }

        &.last {
            .calculator-error-message {
                bottom: 20px;
            }

            .form-select {
                margin-bottom: 40px;
            }
        }
    }

    .calculator-error-message {
        color: red;
        font-size: 12px;
    }

    .desktop-view {
        display: flex;
    }

    .desktop-view-blog {
        display: block;
    }

    .mobile-view {
        display: none;
    }

    .form-wrapper-all {
        .form-control {
            font-size: 16px !important;
            font-weight: 400 !important;
            line-height: 20px !important;
            color: #191919 !important;
            margin-bottom: 35px !important;

            &::placeholder {
                font-size: 16px !important;
                font-weight: 400 !important;
                line-height: 20px !important;
                color: #191919 !important;
            }
        }
    }

    @media (max-width: 767px) {
        .desktop-view,
        .desktop-view-blog {
            //display: none;
            flex-direction: column;

            .col-md-6 {
                max-width: 100%;
                width: 100%;
            }
        }

        .mobile-view {
            display: block;
        }
    }

    .hints {
        font-size: 12px !important;
        color: rgba(25, 25, 25, 0.5) !important;
        margin-bottom: 25px !important;
        margin-top: 5px;
        font-weight: 400;
    }

    .react-select__value-container {
        div:nth-of-type(5) {
            svg {
                display: none;
            }
        }
    }

    .custom {
        border: 1px solid black;
        border-collapse: collapse;

        td,
        th,
        td {
            border: 1px solid black;
        }
    }

    .modal-data__content {
        border-top: none;
    }

    .dc-btn a:hover {
        span {
            color: white;
        }
    }

    .form {
        input[type="Date"] {
            color: #3c3c3b;
        }

        .react-datepicker-wrapper {
            width: 100%;
        }

        .react-datepicker-popper[data-placement^="bottom"]
        .react-datepicker__triangle::before {
            left: -25px;
        }

        .react-datepicker-popper[data-placement^="bottom"]
        .react-datepicker__triangle::after {
            left: -25px;
        }

        .react-datepicker__input-container {
            width: 100%;

            input {
                width: 100%;

                font-size: 14px;
                font-weight: 500;
                color: #3c3c3b;
                border-right: none;
                border-left: none;
                border-top: none;
                outline: none;
                box-shadow: none;
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 10px;
                padding-top: 0;
                height: 33px;
                margin-bottom: 25px;
                border-bottom: 1px solid rgba(60, 60, 59, 0.5);

                &::placeholder {
                    font-size: 14px;
                    font-weight: 500;
                    color: rgba(60, 60, 59, 0.5);
                }
            }
        }

        .form-control {
            font-size: 14px;
            font-weight: 500;
            color: #3c3c3b;
            border-right: none;
            border-left: none;
            border-top: none;
            outline: none;
            box-shadow: none;
            padding-left: 0;
            padding-right: 0;
            padding-bottom: 10px;
            padding-top: 0;
            height: 33px;
            margin-bottom: 25px;
            border-bottom: 1px solid rgba(60, 60, 59, 0.5);

            &::placeholder {
                font-size: 14px;
                font-weight: 500;
                color: rgba(60, 60, 59, 0.5);
            }
        }

        .react-select__indicator {
            padding: 0;
        }

        .react-select__placeholder {
            margin: 0;
            padding: 0;
            font-size: 16px !important;
            font-weight: 400 !important;
            line-height: 20px !important;
            color: #191919 !important;
        }

        .react-select__control {
            border-bottom: 1px solid rgba(60, 60, 59, 0.5);
            margin-bottom: 0px;
            border-right: none;
            border-left: none;
            border-top: none;
            outline: none;
            box-shadow: none;
            padding-left: 0;
            padding-right: 0;

            .react-select__indicator-separator {
                display: none;
            }

            .react-select__input-container {
                padding: 0;
                margin: 0;
            }

            .react-select__single-value {
                margin: 0;
                padding: 0;
                font-size: 14px;
                font-weight: 500;
                color: #3c3c3b;
            }

            .react-select__value-container {
                padding-left: 0;
                padding-right: 0;
                padding-top: 0;
                padding-bottom: 0;
            }
        }
    }

    .result-wrp {
        p {
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            color: #191919;

            span {
                color: #e62e43;
                font-weight: bold;
            }

            margin-bottom: 40px;
        }

        .result-wrap-block {
            background: #191919;

            ul {
                display: flex;
                flex-direction: column;
                padding: 30px 0;

                li {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    margin-bottom: 15px;
                    padding-bottom: 15px;
                    padding-left: 30px;
                    padding-right: 30px;

                    &:last-child {
                        margin-bottom: 0;
                        padding-bottom: 0;
                    }

                    &:last-child {
                        border-bottom: none;
                    }

                    p {
                        margin: 0;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: rgba(255, 255, 255, 1);

                        &.resutl {
                            margin: 0;
                            font-size: 32px;
                            font-weight: 500;
                            line-height: 36px;
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }

    .simplebar-content {
        &::-webkit-scrollbar {
            display: none;
        }
    }

    .react-select__multi-value {
        background: #f1eee9 !important;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
    }

    @media (max-width: 767px) {
        .scroll-div {
            padding: 0 !important;
        }

        .modal-data {
            margin-top: 0 !important;
        }

        .modal-close {
            right: 15px !important;
            //top: 0px !important;
        }

        .result {
            margin-top: 60px;
        }

        .invest-content {
            padding-top: 60px;
            margin-bottom: 60px;
        }

        .modal-data__content {
            margin-top: 60px !important;
            padding: 0 15px !important;
        }
    }
`;

export default Calculator;
